import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './modules/home/home.component'
import { HomeModule } from './modules/home/home.module'
import { ExploreModule } from './modules/explore/explore.module'
import { ExploreComponent } from './modules/explore/explore.component'
import { ExploreMapBoxModule } from './modules/explore_mapbox/explore-mapbox.module'
import { ExploreMapBoxComponent } from './modules/explore_mapbox/explore-mapbox.component'
import { DatasetsModule } from './modules/datasets/datasets.module'
import { DatasetsComponent } from './modules/datasets/datasets.component'
import { LinksModule } from './modules/links/links.module'
import { LinksComponent } from './modules/links/links.component'
import { HelpModule } from './modules/help/help.module'
import { HelpComponent } from './modules/help/help.component'
import { FaqModule } from './modules/faq/faq.module'
import { FaqComponent } from './modules/faq/faq.component'
import { GetInvolvedModule } from './modules/get_involved/get-involved.module'
import { GetInvolvedComponent } from './modules/get_involved/get-involved.component'
import { NewsDetailsComponent } from './modules/home/news-details/news-details.component';


const routes: Routes = [
    {
        path: '',
        redirectTo: '/home',
        pathMatch: 'full',
    },
    {
        path: 'home',
        component: HomeComponent
    },
    {
        path: 'home/news/:id',
        component: NewsDetailsComponent
    },
    {
        path: 'explore',
        component: ExploreMapBoxComponent,
        data: { showFooter: false },
    },
    {
        path: 'explore-mapbox',
        component: ExploreMapBoxComponent,
        data: { showFooter: false },
    },
    {
        path: 'explore-mapbox/type/:tid',
        component: ExploreMapBoxComponent,
        data: { showFooter: false },
    },
    {
        path: 'explore-mapbox/type/:tid/ref/:rid',
        component: ExploreMapBoxComponent,
        data: { showFooter: false },
    },
    {
        path: 'explore/type/:tid',
        component: ExploreMapBoxComponent,
        data: { showFooter: false },
    },
    {
        path: 'explore/type/:tid/ref/:rid',
        component: ExploreMapBoxComponent,
        data: { showFooter: false },
    },
    {
        path: 'datasets',
        component: DatasetsComponent
    },
    {
        path: 'datasets/:refId',
        component: DatasetsComponent
    },   
    
    {
        path: 'faq',
        component: FaqComponent,
    },
    {
        path: 'links',
        component: LinksComponent
    },
    {
        path: 'help/:id',
        component: HelpComponent
    },
    {
        path: 'get-involved',
        component: GetInvolvedComponent
    }
];

@NgModule({
    imports: [  RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class AppRoutingModule { }
